import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";

@Injectable({
  providedIn: 'root'
})

export class MatPaginatorIntlPTBR extends MatPaginatorIntl {
  override itemsPerPageLabel = "Itens por página";
  override nextPageLabel = "Próximo";
  override previousPageLabel = "Anterior";
  override firstPageLabel = "Primeira Página";
  override lastPageLabel = "Última Página";  

  override getRangeLabel = function(page, pageSize, length) {
    if (length === 0 || pageSize === 0) {
      return "0 de 0";
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return startIndex + 1 + " - " + endIndex + " de " + length;
  };
}
